import * as React from 'react';

import SearchableDropdown from 'components/inputs/searchable-dropdown/SearchableDropdown';

import DiscoveryFiltersTitle from 'modules/discovery/components/filters/title/DiscoveryFiltersTitle';

import { __t, applyTranslations } from 'utils/language';
import { dataCommonToComponent, dataComponentToCommon } from 'utils/data/data';
import { countrySearchToDropdownItems } from 'utils/locations';

import './discovery-content-filters-countries.scss';

import type { Data, DiscoveryCreatorsFilters, MixedSelectDropdownItem } from 'types';

applyTranslations(require('./discovery-content-filters-countries.i18n.json'));

type Props = {
  filters: DiscoveryCreatorsFilters,
  lastStateReset: number,
  handleFiltersUpdate: (a: any) => void
};

const msgKey = 'discovery_content_filters_countries';

class DiscoveryContentFiltersCountries extends React.PureComponent<Props> {
  static defaultProps = {
    filters: {},
    lastStateReset: Date.now(),
    handleFiltersUpdate: () => {}
  };

  handleLocationChange = (items: Array<MixedSelectDropdownItem>, data?: Data | null) => {
    if (!data || !data.name) {
      return;
    }

    this.handleUpdate({
      [data.name]: items.filter((item) => item.isSelected).map(dataComponentToCommon)
    });
  };

  handleUpdate(result: any): void {
    const { handleFiltersUpdate } = this.props;

    if (handleFiltersUpdate) {
      handleFiltersUpdate(result);
    }
  }

  renderSearchableDropdown(key: 'cities' | 'countries'): React.ReactNode {
    const { filters, lastStateReset } = this.props;

    return (
      <SearchableDropdown
        key={`discovery-content-filters-countries-${key}-${lastStateReset}`}
        items={filters[key].map(dataCommonToComponent)}
        dataFetcher={countrySearchToDropdownItems}
        data={{
          name: key
        }}
        onItemsUpdate={this.handleLocationChange}
      />
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-content-filters-countries">
        <div className="discovery-content-filters-profiles__section">
          <DiscoveryFiltersTitle
            title={__t(`${msgKey}.labels.country`)}
          />
          {this.renderSearchableDropdown('countries')}
        </div>
      </div>
    );
  }
}

export default DiscoveryContentFiltersCountries;
